import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EChargeBannerService {
  private _wasBannerDisplayedInSession: boolean;
  private readonly iOSDeviceIds = [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod',
  ];

  constructor() {}

  public get isAndroid(): boolean {
    return /Android/i.test(navigator.userAgent);
  }

  public get isIOS(): boolean {
    return (
      this.iOSDeviceIds.includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    );
  }

  public get wasBannerDisplayedInSession(): boolean {
    return this._wasBannerDisplayedInSession;
  }

  public set wasBannerDisplayedInSession(wasDisplayed: boolean) {
    this._wasBannerDisplayedInSession = wasDisplayed;
  }
}
